<script setup lang="ts">
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';

  const lab = useMatrixFillLabContext();
</script>

<template>
  <div
    class="flex flex-col gap-1"
    data-testid="saved-responses"
  >
    <p class="font-semibold">
      Respostas salvas ({{ lab.responses.value.length }})
    </p>
    <p
      v-if="lab.responses.value.length === 0"
      class="italic text-[var(--color-gray-05)]"
    >
      Nenhuma resposta salva ainda. Cada resposta salva vira uma linha do relatório.
    </p>
    <ul
      v-else
      class="flex flex-col gap-1"
    >
      <li
        v-for="response in lab.responses.value"
        :key="response.id"
        class="flex items-center gap-2 rounded-md bg-[var(--color-white-02)] px-2 py-1"
      >
        <span class="font-semibold">{{ response.label }}</span>
        <span class="truncate text-[var(--color-gray-05)]">por {{ response.subjectLabel }}</span>
        <button
          type="button"
          class="ml-auto text-[10px] text-red-600 underline"
          @click="lab.removeResponse(response.id)"
        >
          remover
        </button>
      </li>
    </ul>
  </div>
</template>
